import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from '../store';

interface Product {
    id: string | number;
    name: string;
    price: number;
    image_dir: string | string[];
    category: string;
    material?: string;
    description?: string;
    stock?: number;
}

interface QuickViewState {
    isOpen: boolean;
    product: Product | null;
}

const initialState: QuickViewState = {
    isOpen: false,
    product: null,
};

const quickViewSlice = createSlice({
    name: 'quickView',
    initialState,
    reducers: {
        openQuickView: (state, action: PayloadAction<Product>) => {
            state.isOpen = true;
            state.product = action.payload;
        },
        closeQuickView: (state) => {
            state.isOpen = false;
            state.product = null;
        },
    },
});

export const { openQuickView, closeQuickView } = quickViewSlice.actions;

// Selectors
export const selectQuickViewState = (state: IRootState) => state.quickView;
export const selectQuickViewProduct = (state: IRootState) => state.quickView.product;

export default quickViewSlice.reducer;
